uniform float time;
uniform float progress;
uniform sampler2D texture1;
uniform vec3 uColor1;
uniform vec3 uColor2;
uniform vec3 uColor3;
uniform float uRange1;
uniform float uRange2;
uniform float uScale1;
uniform float uScale2;
uniform float uRotation;
uniform vec2 resolution;
varying vec2 vUv;
varying vec3 vPosition;
varying float vTest;
varying vec3 v_color;
float PI = 3.141592653589793238;

void main()	{

	// vec3 uColor1 =  vec3(0.108, 0.464, 0.760);

	gl_FragColor =vec4(vTest,0.,1.,1.);
	gl_FragColor =vec4(v_color,1.);
}